/**
 * @file A list of all image size codes as returned for each Image (i.e. Thumbnail_url).
 */

/**
 * @enum IMAGE_SIZE_CODE
 * @type {{SMALL: string, MEDIUM: string, MEDIUM2X: string, LARGE: string, LARGE2X: string, LARGE1X: string, SMALL2X: string}}
 */
const IMAGE_SIZE_CODE = {
  SMALL: 'small',
  SMALL2X: 'small2x',
  MEDIUM: 'medium',
  MEDIUM2X: 'medium2x',
  LARGE: 'large',
  LARGE1X: 'large1x',
  LARGE2X: 'large2x',
};

export { IMAGE_SIZE_CODE };
